import React from 'react';
import PropTypes from 'prop-types';
import DropDown from '..';
import OptionsContainer from '../OptionsContainer';
import HeaderComponent from '../HeaderComponent';

const SimpleDropDown = ({
  dropdownOpen,
  setDropdownOpen,
  textHeader,
  children,
  tooltip = '',
  textColor = '',
  borderColor = 'midDarkGray',
  width = '100%',
  height = '48px',
  marginTop = '3px',
  marginLeft = '13px',
  chevronHeight = '21px',
  chevronWidth = '16px'
}) => {
  return (
    <DropDown
      width={width}
      isOpen={dropdownOpen}
      setIsOpen={e => {
        e.stopPropagation();
        setDropdownOpen(!dropdownOpen);
      }}
      tooltip={tooltip}
      headerComponent={React.createElement(
        'div',
        {},
        <HeaderComponent
          isOpen={dropdownOpen}
          text={textHeader}
          textColor={textColor}
          borderColor={borderColor}
          width={width}
          height={height}
          marginTop={marginTop}
          marginLeft={marginLeft}
          chevronHeight={chevronHeight}
          chevronWidth={chevronWidth}
        />
      )}
      dataPanel='defaultOption'
    >
      <OptionsContainer isOpen={dropdownOpen} onClose={setDropdownOpen} borderColor={borderColor} width={width}>
        {children}
      </OptionsContainer>
    </DropDown>
  );
};

SimpleDropDown.propTypes = {
  dropdownOpen: PropTypes.bool.isRequired,
  setDropdownOpen: PropTypes.func.isRequired,
  textHeader: PropTypes.string.isRequired
};

export default SimpleDropDown;
